import { BreadcrumbModel } from "../models/breadcrumbs.model";

function crumb(label: string, href: string): BreadcrumbModel {
  return { label, href };
}

export default crumb;
